import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';
import { AvatarSize } from '../../../containers/ProfilePage/reducer';

interface ImageProps {
	x: number;
	y: number;
	width: number;
	height: number;
	size: AvatarSize;
}

const getScale = (size: AvatarSize): number => size / AvatarSize.BIG;

const Image = styled('div')`
	position: relative;
	flex: ${({ size }: ImageProps) => `0 0 ${size}px`};
	height: ${({ size }: ImageProps) => `${size}px`};
	margin-right: 15px;
	border-radius: 50%;
	background-color: ${NewStyleColor.Grey100};
	overflow: hidden;

	img {
		position: absolute;
		width: ${({ width, size }: ImageProps) => `${width * getScale(size)}px`};
		height: ${({ height, size }: ImageProps) => `${height * getScale(size)}px`};
		transform: translate(${({ x, y, size }: ImageProps) => `${x * getScale(size)}px, ${y * getScale(size)}px`});
	}

	svg {
		width: 100%;
		height: 100%;
	}
`;

export {
	Image,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProfilePage/UserAvatar/styles.ts